export default "<app-contacts-list></app-contacts-list>\r\n";